import { GetArticleBySlug_getArticleBySlug_sourceStream } from 'api/articles/types/GetArticleBySlug';
import EventMediaCard from 'components/OrderStream/StreamEventMedia/EventMediaCard/EventMediaCard';
import styles from './ArticleWatchInterview.module.scss';

type ArticleWatchInterviewProps = {
  stream: GetArticleBySlug_getArticleBySlug_sourceStream;
  // A stream copy often has no thumbnail of its own; the article cover shows the same interview.
  fallbackImageUrl?: string;
};

const ArticleWatchInterview = ({
  stream,
  fallbackImageUrl,
}: ArticleWatchInterviewProps): JSX.Element => (
  <section className={styles.root} aria-labelledby="article-watch-interview">
    <h2 id="article-watch-interview" className={styles.title}>
      Watch the full interview
    </h2>
    <div className={styles.card}>
      <EventMediaCard
        item={{
          id: stream.id,
          title: stream.name || '',
          publisherName: stream.store.storeDetails?.storeName || '',
          imageUrl: stream.imageURL || fallbackImageUrl || '',
          scheduledAt: stream.scheduleDateUtc,
          isFree: !stream.price,
          price: stream.price,
          href: `/${stream.store.slug}/streams/${stream.slug}`,
        }}
      />
    </div>
  </section>
);

export default ArticleWatchInterview;
